/* =====================================================================
   Cave Larégnère — Ajout rapide au panier (autonome, réutilise le panier Eurus).
   N'ouvre PAS de panier parallèle : POST /cart/add.js sur le MÊME panier Shopify,
   puis rafraîchit le compteur (#cart-icon-bubble) et le drawer (#CartDrawer) via la
   Section Rendering API, émet les events Eurus, et affiche une confirmation sobre.
   Délégation d'événements → fonctionne aussi sur les cartes injectées par les filtres.
   ===================================================================== */
(function () {
  'use strict';
  var LIVE = null, TOAST = null;

  function ensureUI() {
    if (!LIVE) {
      LIVE = document.createElement('div');
      LIVE.className = 'cl-visually-hidden';
      LIVE.setAttribute('aria-live', 'polite');
      LIVE.setAttribute('role', 'status');
      document.body.appendChild(LIVE);
    }
    if (!TOAST) {
      TOAST = document.createElement('div');
      TOAST.className = 'cl-toast';
      TOAST.setAttribute('role', 'status');
      document.body.appendChild(TOAST);
    }
  }
  function announce(msg) { ensureUI(); LIVE.textContent = ''; setTimeout(function(){ LIVE.textContent = msg; }, 30); }
  function showToast(html) {
    ensureUI();
    TOAST.innerHTML = html;
    TOAST.classList.add('is-shown');
    clearTimeout(TOAST._t);
    TOAST._t = setTimeout(function () { TOAST.classList.remove('is-shown'); }, 4500);
  }
  function sectionIdOf(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    var host = el.closest('[id^="shopify-section-"]');
    return host ? host.id.replace('shopify-section-', '') : null;
  }
  function replaceSection(id, html) {
    if (!id || !html) return;
    var host = document.getElementById('shopify-section-' + id);
    if (!host) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-' + id);
    host.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
  }
  function setLabel(btn, text) {
    var l = btn.querySelector('.cl-atc__label');
    if (l) l.textContent = text;
  }
  function getLabel(btn) {
    var l = btn.querySelector('.cl-atc__label');
    return l ? l.textContent : 'Ajouter au panier';
  }

  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var original = getLabel(btn);
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.classList.remove('is-error', 'is-added');

    var bubbleSec = sectionIdOf('#cart-icon-bubble') || sectionIdOf('#mobile-cart-icon-bubble');
    var drawerSec = sectionIdOf('#CartDrawer');
    var sections = [bubbleSec, drawerSec].filter(Boolean);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
      .then(function (res) {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('is-loading');
        if (!res.ok) { throw new Error((res.d && res.d.description) || 'add_error'); }
        var d = res.d;
        if (d.sections) {
          replaceSection(bubbleSec, d.sections[bubbleSec]);
          replaceSection(drawerSec, d.sections[drawerSec]);
        }
        btn.classList.add('is-added');
        setLabel(btn, 'Ajouté ✓');
        setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 2200);
        announce('Produit ajouté au panier.');
        showToast('<span class="cl-toast__ico" aria-hidden="true">✓</span><span class="cl-toast__txt">Ajouté au panier</span><a class="cl-toast__link" href="/cart">Voir le panier</a>');
        try {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true, detail: d }));
          document.dispatchEvent(new CustomEvent('eurus:product:added', { bubbles: true, detail: d }));
        } catch (e) {}
      })
      .catch(function () {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setLabel(btn, 'Réessayer');
        announce('Une erreur est survenue, veuillez réessayer.');
        setTimeout(function () { btn.classList.remove('is-error'); setLabel(btn, original); }, 2600);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cl-atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();

/* Recherche interne dans les longues listes de filtres (Appellation, Producteur…) */
(function () {
  'use strict';
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.cl-facet-search');
    if (!input) return;
    var wrap = input.closest('.cl-facet-search-wrap');
    var list = wrap && wrap.parentNode.querySelector('.cl-facet-list');
    if (!list) return;
    var q = norm(input.value.trim());
    var shown = 0;
    list.querySelectorAll('.cl-facet-item').forEach(function (li) {
      var lbl = li.getAttribute('data-label') || norm(li.textContent);
      var match = q === '' || norm(lbl).indexOf(q) > -1;
      li.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    var empty = wrap.querySelector('.cl-facet-search__empty');
    if (empty) empty.hidden = shown !== 0;
  });
})();
